import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门推荐', href: '#cards' },
  { label: '热播排行', href: '#ranking' },
  { label: '用户评价', href: '#comments' },
  { label: 'APP下载', href: '#app' },
  { label: '平台优势', href: '#features' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 group shrink-0"
          >
            <span className="font-heading text-2xl md:text-3xl font-bold text-primary-500 tracking-tight">
              90影院
            </span>
            <span className="hidden md:inline-block text-xs text-foreground-400 bg-background-200/80 px-2 py-0.5 rounded font-label">
              8090的影视乐园
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 ${
                  item.label === '首页'
                    ? 'text-primary-500'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Search trigger (desktop only, visual) */}
          <div className="hidden md:flex items-center gap-3 shrink-0">
            <div className="flex items-center gap-2 bg-background-200/60 rounded-full px-4 py-2 cursor-pointer border border-background-300/40 hover:border-background-400/60 transition-colors">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <span className="text-sm text-foreground-500 whitespace-nowrap">搜索影片...</span>
            </div>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile nav panel */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-300/40">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  item.label === '首页'
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60'
                }`}
              >
                {item.label}
              </a>
            ))}
            {/* Mobile search */}
            <div className="flex items-center gap-2 bg-background-200/60 rounded-full px-4 py-3 mt-2 border border-background-300/40">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <span className="text-sm text-foreground-500">搜索影片...</span>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}